import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../css/Terms.css';

const TermsOfService = () => {
    const navigate = useNavigate();

    return (
        <div className="terms-page">
            <div className="terms-container">
                <div className="terms-header">
                    <h1>이용약관</h1>
                    <button className="back-button" onClick={() => navigate(-1)}>
                        뒤로가기
                    </button>
                </div>
                
                <div className="terms-content">
                    <div className="terms-section">
                        <p>제정 2025. 08. 01.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제1조(목적)</h2>
                        <p>본 약관은 주식회사 스마트건강도시랩(이하 '회사'라 함)이 제공하는 스마트건강코치 V-Care 서비스('서비스'라 함)의 이용에 관한 회사와 이용자 간의 권리, 의무 및 책임사항을 규정함을 목적으로 합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제2조(정의)</h2>
                        <p>1. '회원'이라 함은 본 약관에 동의하고 가입하여 계정을 부여받은 자를 의미합니다.</p>
                        <p>2. '이용자'라 함은 회원 및 회원 가입 없이 본 서비스를 이용하는 자 모두를 말합니다.</p>
                        <p>3. '사용자'라 함은 스마트건강코치 V-Care 서비스와 함께 이용 가능한 스마트건강코치 서비스에 회원 가입하여 스마트건강코치 서비스를 이용하는 자를 의미합니다.</p>
                        <p>4. '건강 데이터'라 함은 혈압, 혈당, 체중, 심박수 등 회원이 입력하거나 연결된 기기를 통해 수집되는 사용자(들)의 건강 관련 정보를 의미합니다.</p>
                        <p>5. '스마트건강코치 V-Care'는 회원(보호자)이 자신을 보호자(또는 정보 공유 지정자)로 지정한 사용자(들)의 건강 데이터 및 분석 결과를 모니터링할 수 있도록 해주는 서비스로서 웹, API(Application Programming Interface)의 형태로 제공됩니다.</p>
                        <p>6. '건강 측정 기기'라 함은 혈압계(HEM-7142T2), 혈당계(케어센스 N Premier GM01AAB), 체중계(HN-300T2) 및 이와 호환되는 측정 기기를 의미합니다.</p>
                        <p>7. '자가관리 패키지'라 함은 스마트건강코치 앱, 태블릿 단말기, 혈압계, 혈당계, 체중계를 포함하는 패키지(package)를 의미합니다.</p>
                        <p>8. '가족안심 패키지'라 함은 위 '자가관리 패키지'에 스마트건강코치 V-Care 웹 서비스가 추가된 패키지를 의미합니다.</p>
                        <p>9. '소비자'라 함은 가족안심 패키지를 구매한 자를 의미합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제3조(약관의 효력 및 변경)</h2>
                        <p>1. 본 약관은 이용자가 서비스에 접속한 시점부터 효력을 가집니다. 회원의 경우 회원 가입 시 본 약관에 동의하는 것으로 봅니다.</p>
                        <p>2. 회사는 관계 법령을 위반하지 않는 범위 내에서 본 약관을 변경할 수 있습니다.</p>
                        <p>3. 약관 변경 시 회사는 변경 내용을 변경 약관 적용일 7일 전에 회원에게 공지합니다.</p>
                        <p>4. 회원이 변경된 약관에 동의하지 않을 경우 서비스 이용을 중단하고 회원 탈퇴할 수 있습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제4조(스마트건강코치 V-Care 상세)</h2>
                        <p>1. 스마트건강코치 V-Care는 웹, API 형태로 제공됩니다.</p>
                        <p>2. 스마트건강코치 V-Care는 제2조 제3호의 스마트건강코치 앱과 결합되어 사용됩니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제5조(서비스의 제공)</h2>
                        <p>1. 스마트건강코치 V-Care는 회원을 보호자(또는 정보 공유 지정자)로 지정한 사용자(들)의 다음과 같은 정보를 회원에게 제공합니다.</p>
                        <p>1) 혈압 수치 및 변화 추이</p>
                        <p>2) 혈당 수치 및 변화 추이</p>
                        <p>3) 심박수 및 기타 생체 신호 데이터</p>
                        <p>4) 스마트건강코치 앱 내 기록된 측정 시점 및 측정 결과에 대한 종합 현황</p>
                        <p>2. 스마트건강코치 V-Care는 위 1.의 정보 등을 회원에게 대시보드 등의 형태로 제공합니다.</p>
                        <p>3. 스마트건강코치 V-Care는 위 2.의 대시보드를 통해 회원이 사용자(들)의 건강 관련 응급 상황에 대처하거나 사용자(들)의 건강 상태를 모니터링할 수 있는 서비스를 제공합니다.</p>
                        <p>4. 사용자(들)이 회원에 대한 사용자(들)의 건강 데이터 정보 공유 서비스를 해지하면 위 1, 2, 3의 서비스는 중단됩니다.</p>
                        <p>5. 회사는 위 전체 서비스의 일부 또는 전부를 변경할 수 있으며, 변경 시 사전에 공지합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제6조(회원가입, 계정 관리 및 서비스 이용)</h2>
                        <p>1. 본 서비스는 성인(만 19세 이상)만 가입할 수 있습니다.</p>
                        <p>2. 회원 가입 및 사용자(들) 정보의 입력은 실제 정보를 기반으로 하여야 합니다.</p>
                        <p>3. 계정 관리 책임은 회원 본인에게 있으며, 타인에게 양도할 수 없습니다.</p>
                        <p>4. 본 약관의 내용을 위반하여 서비스 이용 중지 또는 차단 처분을 받은 회원은 본 서비스를 이용할 수 없습니다.</p>
                        <p>5. 계정 도용 또는 부정 이용 사실을 인지한 경우 즉시 회사에 신고하여야 합니다.</p>
                        <p>6. 본 서비스의 운영을 방해하는 등 본 서비스를 통상적인 방법으로 사용하지 않은 것이 확인된 회원의 경우 회사는 그 회원의 계정을 중지, 차단 또는 삭제할 수 있습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제7조(회원의 탈퇴)</h2>
                        <p>1. 회원은 언제든지 본 서비스에서 탈퇴할 수 있습니다.</p>
                        <p>2. 회원이 탈퇴를 신청한 경우 탈퇴 신청일로부터 30일간의 유예기간을 거친 후 회원을 특정할 수 있는 정보인 회원의 이름 정보는 파기 처리됩니다.</p>
                        <p>3. 위 2.의 탈퇴 유예기간 중에는 본 서비스의 관리자에게 탈퇴 신청을 철회할 수 있습니다.</p>
                        <p>4. 탈퇴 유예기간이 경과되어 탈퇴 및 상기 개인 신상 정보의 파기가 완료된 경우에는, 신규 회원 가입을 통해서 서비스를 새롭게 이용하실 수 있습니다.</p>
                        <p>5. 탈퇴 유예기간 동안에는 동일한 개인 정보를 이용한 신규 회원 가입이 제한되므로, 탈퇴 신청의 철회를 통해서 계정과 데이터를 복구하시기 바랍니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제8조(이용자의 의무)</h2>
                        <p>1. 이용자는 다음 행위를 해서는 안 됩니다.</p>
                        <p>1) 타인의 건강 데이터를 무단으로 수집, 이용하는 행위</p>
                        <p>2) 회사의 시스템을 해킹하거나 비정상적으로 이용하는 행위</p>
                        <p>3) 허위 정보를 등록하는 행위</p>
                        <p>4) 서비스 운영을 방해하는 행위</p>
                        <p>5) 회사의 명시적인 서면 동의 없이 서비스, 또는 페이지의 레이아웃 및 디자인을 비롯한, 서비스 내의 개별 요소를 이용, 표시, 반영하거나 구성하는 행위</p>
                        <p>6) 회사의 명시적인 서면 동의 없이 서비스의 이름, 상표 또는 로고, 또는 독점 정보를 사용하는 행위</p>
                        <p>7) 서비스의 비 공용 부분, 컴퓨터 시스템, 또는 제공업체의 기술 전달 시스템에 접속하거나 무단으로 변경하는 행위</p>
                        <p>8) 시스템의 취약성을 테스트하거나 보안 또는 인증 조치를 침해하는 행위</p>
                        <p>9) 제공업체 또는 기타 제3자가 서비스 또는 콘텐츠 보호를 위해 취한 기술 조치를 우회적으로 회피하는 행위</p>
                        <p>10) 승인된 접속, 서비스, 또는 기존 API가 아닌 다른 메커니즘을 이용하여 서비스 또는 콘텐츠에 접속하는 행위</p>
                        <p>11) 앱 또는 서비스의 기타 부분을 수정, 역컴파일, 분해, 역설계, 무단 변경하거나 또는 다른 방식으로 이들의 소스 코드를 획득하려고 시도하는 행위</p>
                        <p>2. 이용자가 위 1.의 행위를 한 것이 확인되는 경우 회사는 이용자에게 금지행위중지 및 손해배상을 청구할 수 있습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제9조(저작권 등 지식재산권)</h2>
                        <p>1. 본 서비스가 제공하는 콘텐츠의 저작권은 회사에게 있습니다.</p>
                        <p>2. 이용자는 본 서비스의 콘텐츠에 대하여 이용권 및 재이용권 설정, 복사, 개작, 수정, 번역, 공개, 파생 저작물 작성, 배포, 판매, 임대, 리스, 양도, 이전, 일반 공개, 공연, 방송하거나, 기타 방식을 이용하여 상업적으로 활용할 수 없습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제10조(환불 및 반품)</h2>
                        <p>1. 회사는 전자상거래법에 따른 청약철회 및 환불 절차를 준수합니다.</p>
                        <p>2. 단순 변심에 의한 환불 및 반품</p>
                        <p>1) 소비자는 패키지 내 태블릿 및 건강 측정 기기(본 조에서 이하 '제품'이라 함) 수령일로부터 7일 이내에 단순 변심에 의한 반품 및 환불을 요청할 수 있습니다.</p>
                        <p>2) 다음의 경우에는 반품이 제한될 수 있습니다.</p>
                        <p>(1) 소프트웨어 설치 및 활성화(시리얼번호 입력 등)가 완료된 경우</p>
                        <p>(2) 제품의 포장이 훼손되거나 사용 흔적이 있는 경우</p>
                        <p>(3) 소비자의 귀책사유로 제품이 훼손 또는 멸실된 경우</p>
                        <p>3. 제품 이상, 불량에 의한 환불 및 교환</p>
                        <p>1) 제품에 제조상 불량이 있는 경우 각 제품 제조사의 수리 또는 교환/환불 정책에 따라 처리됩니다.</p>
                        <p>2) 스마트건강코치 앱의 기능상 오류 또는 기술적 문제 발생 시, 문제 해결을 위한 기술지원이 우선 제공되며, 문제가 해결되지 않을 경우 부분 환불 또는 전액 환불이 가능합니다.</p>
                        <p>4. 환불 처리 절차</p>
                        <p>1) 환불 신청은 당사 고객센터(070-4348-0881) 또는 이메일로 접수하셔야 하며, 승인 후 반품 주소 및 상세 절차가 안내됩니다.</p>
                        <p>이메일 주소: smarthealthcitylab@shcl.co.kr</p>
                        <p>2) 환불은 제품 회수 및 상태 확인 후 7영업일 이내에 결제한 수단으로 진행됩니다.</p>
                        <p>5. 비용 부담</p>
                        <p>1) 단순 변심에 의한 반품 시 왕복 배송비는 소비자 부담입니다.</p>
                        <p>2) 제품 이상/불량에 따른 반품의 경우 왕복 배송비는 회사 부담입니다.</p>
                        <p>6. 부분 환불 및 반품 정책</p>
                        <p>1) 스마트건강코치 앱은 디지털 콘텐츠로서 이용 또는 다운로드가 시작된 경우 환불이 제한됩니다.</p>
                        <p>2) 제품 중 일부(예: 의료기기만 반품 등)의 반품은 원칙적으로 불가하나, 사유에 따라 부분 환불이 적용될 수 있으며, 이 경우 앱 사용료, 태블릿 감가상각, 건강 측정 기기 정가 등을 기준으로 정산됩니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제11조(의료 관련 면책)</h2>
                        <p>1. 본 서비스가 제공하는 모든 콘텐츠, 건강 데이터 분석 및 조언은 보조적 건강관리 서비스일뿐 의료 행위가 아니며 의료 전문가의 진료를 대체하지 않는 참고용 정보입니다.</p>
                        <p>2. 사용자(들)의 신체 등 건강에 대한 실제 진단, 처방 및 치료는 반드시 의료 전문가의 상담을 받아야 합니다.</p>
                        <p>3. 회사는 회원이 본 서비스가 제공하는 건강 데이터 및 건강 콘텐츠를 잘못 해석하거나 의료적 판단을 대신하여 발생한 문제에 대해 책임을 지지 않습니다.</p>
                        <p>4. 회사는 건강 관련 콘텐츠의 정확성, 완전성, 최신성에 대해 보증하지 않으며, 본 서비스의 콘텐츠는 의료 자문을 대체하지 않습니다.</p>
                        <p>5. 회사는 본 서비스와 관련하여 사용자(들)의 건강 문제에 대하여 아무런 책임을 지지 않습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제12조(개인정보 보호)</h2>
                        <p>개인정보 보호는 별도의 개인정보처리방침에 따릅니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제13조(일반 면책)</h2>
                        <p>1. 회사는 천재지변, 불가항력 사유로 인한 서비스 중단에 대해 책임을 지지 않습니다.</p>
                        <p>2. 회사는 회원 상호 간 분쟁에 개입하지 않으며 이로 인한 손해에 대해서도 책임을 지지 않습니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>제14조(준거법 및 재판관할)</h2>
                        <p>1. 본 약관과 관련하여 발생하는 분쟁은 대한민국 법률을 준거법으로 합니다.</p>
                        <p>2. 관할 법원은 회사 본사 소재지를 관할하는 법원으로 합니다.</p>
                    </div>

                    <div className="terms-section">
                        <h2>부칙(2025. 08. 01.)</h2>
                        <p>이 이용약관은 2025년 08월 01일부터 시행한다.</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default TermsOfService; 